@if (integrationType?.description?.length) {
  <div class="overview__list">
    @for (element of integrationType?.description; track element) {
      <div class="overview__item">
        <pdq-heading element="h6">{{ element.title }}</pdq-heading>
        @if (isArray(element?.content)) {
          <div class="overview__item__content">
            @for (contentEl of element.content; track contentEl) {
              <li>{{ contentEl }}</li>
            }
          </div>
        } @else {
          <div class="overview__item__content">{{ element.content }}</div>
        }
      </div>
    }
  </div>
}
